import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    removeAdministracaoTransfFinAdm: ['administracao'],
    removeOrgaoTransfFinAdm: ['orgao'],
    removeRecursoVinculadoTransfFinAdm: ['recursoVinculado'],
    removeRecursoDestinacaoTransfFinAdm: ['recursoDestinacao'],
    setMostraAplicarFiltroTransfFinAdm: [],
    limpaFiltroTransfFinAdm: [],
    aplicarFiltroTransfFinAdm: ['filtro'],
})

const INITIAL_STATE = {
    administracoes: [],
    orgaos: [],
    recursosVinculados: [],
    recursosDestinacao: [],
    mostraAplicarFiltro: false,
}

const removeAdministracao = (state = INITIAL_STATE, action) => {
    state.administracoes.splice(state.administracoes.indexOf(action.administracao), 1)

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.administracoes = Array.from(state.administracoes)
    return { ...state, mostraAplicarFiltro: true }
}

const removeOrgao = (state = INITIAL_STATE, action) => {
    state.orgaos.splice(state.orgaos.indexOf(action.orgao))

    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.orgaos = Array.from(state.orgaos)
    return { ...state, mostraAplicarFiltro: true }
}

const removeRecursoVinculado = (state = INITIAL_STATE, action) => {
    state.recursosVinculados.splice(state.recursosVinculados.indexOf(action.recursoVinculado), 1)
    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.recursosVinculados = Array.from(state.recursosVinculados)
    return { ...state, mostraAplicarFiltro: true }
}

const removeRecursoDestinacao = (state = INITIAL_STATE, action) => {
    state.recursosDestinacao.splice(state.recursosDestinacao.indexOf(action.recursoDestinacao), 1)
    //A lista utiliza referencia
    //Então precisei criar uma nova lista
    //para o select do react atualizar quando remover atributos
    state.recursosDestinacao = Array.from(state.recursosDestinacao)

    return { ...state, mostraAplicarFiltro: true }
}

const setMostraAplicarFiltro = (state = INITIAL_STATE, action) => {
    return { ...state, mostraAplicarFiltro: !state.mostraAplicarFiltro }
}

const aplicarFiltro = (state = INITIAL_STATE, action) => {
    action.filtro.mostraAplicarFiltro = false
    return action.filtro
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    //TransfFinAdm
    [Types.REMOVE_ADMINISTRACAO_TRANSF_FIN_ADM]: removeAdministracao,
    [Types.REMOVE_ORGAO_TRANSF_FIN_ADM]: removeOrgao,
    [Types.REMOVE_RECURSO_VINCULADO_TRANSF_FIN_ADM]: removeRecursoVinculado,
    [Types.REMOVE_RECURSO_DESTINACAO_TRANSF_FIN_ADM]: removeRecursoDestinacao,
    [Types.SET_MOSTRA_APLICAR_FILTRO_TRANSF_FIN_ADM]: setMostraAplicarFiltro,
    [Types.LIMPA_FILTRO_TRANSF_FIN_ADM]: limpaFiltro,
    [Types.APLICAR_FILTRO_TRANSF_FIN_ADM]: aplicarFiltro,
})
